[
  { "code": "AF", "nationality": "Afgano" },
  { "code": "AL", "nationality": "Albanés" },
  { "code": "DZ", "nationality": "Argelino" },
  { "code": "AS", "nationality": "Samoano Americano" },
  { "code": "AD", "nationality": "Andorrano" },
  { "code": "AO", "nationality": "Angoleño" },
  { "code": "AI", "nationality": "Anguilense" },
  { "code": "AG", "nationality": "Antiguano o Barbudense" },
  { "code": "AR", "nationality": "Argentino" },
  { "code": "AM", "nationality": "Armenio" },
  { "code": "AU", "nationality": "Australiano" },
  { "code": "AT", "nationality": "Austriaco" },
  { "code": "AZ", "nationality": "Azerbaiyano" },
  { "code": "BS", "nationality": "Bahameño" },
  { "code": "BH", "nationality": "Bahreiní" },
  { "code": "BD", "nationality": "Bangladesí" },
  { "code": "BB", "nationality": "Barbadense" },
  { "code": "BY", "nationality": "Bielorruso" },
  { "code": "BE", "nationality": "Belga" },
  { "code": "BZ", "nationality": "Beliceño" },
  { "code": "BJ", "nationality": "Beninés" },
  { "code": "BM", "nationality": "Bermudeño" },
  { "code": "BT", "nationality": "Butanés" },
  { "code": "BO", "nationality": "Boliviano" },
  { "code": "BA", "nationality": "Bosnio o Herzegovino" },
  { "code": "BW", "nationality": "Botsuano" },
  { "code": "BR", "nationality": "Brasileño" },
  { "code": "BN", "nationality": "Bruneano" },
  { "code": "BG", "nationality": "Búlgaro" },
  { "code": "BF", "nationality": "Burkines" },
  { "code": "BI", "nationality": "Burundés" },
  { "code": "KH", "nationality": "Camboyano" },
  { "code": "CM", "nationality": "Camerunés" },
  { "code": "CA", "nationality": "Canadiense" },
  { "code": "CV", "nationality": "Caboverdiano" },
  { "code": "CF", "nationality": "Centroafricano" },
  { "code": "TD", "nationality": "Chadiano" },
  { "code": "CL", "nationality": "Chileno" },
  { "code": "CN", "nationality": "Chino" },
  { "code": "CO", "nationality": "Colombiano" },
  { "code": "KM", "nationality": "Comorense" },
  { "code": "CG", "nationality": "Congoleño" },
  { "code": "CR", "nationality": "Costarricense" },
  { "code": "HR", "nationality": "Croata" },
  { "code": "CU", "nationality": "Cubano" },
  { "code": "CY", "nationality": "Chipriota" },
  { "code": "CZ", "nationality": "Checo" },
  { "code": "DK", "nationality": "Danés" },
  { "code": "DJ", "nationality": "Yibutiano" },
  { "code": "DM", "nationality": "Dominiqués" },
  { "code": "DO", "nationality": "Dominicano" },
  { "code": "EC", "nationality": "Ecuatoriano" },
  { "code": "EG", "nationality": "Egipcio" },
  { "code": "SV", "nationality": "Salvadoreño" },
  { "code": "GQ", "nationality": "Ecuatoguineano" },
  { "code": "ER", "nationality": "Eritreo" },
  { "code": "EE", "nationality": "Estonio" },
  { "code": "ET", "nationality": "Etíope" },
  { "code": "FJ", "nationality": "Fiyiano" },
  { "code": "FI", "nationality": "Finlandés" },
  { "code": "FR", "nationality": "Francés" },
  { "code": "GA", "nationality": "Gabonés" },
  { "code": "GM", "nationality": "Gambiano" },
  { "code": "GE", "nationality": "Georgiano" },
  { "code": "DE", "nationality": "Alemán" },
  { "code": "GH", "nationality": "Ghanés" },
  { "code": "GR", "nationality": "Griego" },
  { "code": "GD", "nationality": "Granadino" },
  { "code": "GT", "nationality": "Guatemalteco" },
  { "code": "GN", "nationality": "Guineano" },
  { "code": "GW", "nationality": "Guineano Bissauense" },
  { "code": "GY", "nationality": "Guyanés" },
  { "code": "HT", "nationality": "Haitiano" },
  { "code": "HN", "nationality": "Hondureño" },
  { "code": "HU", "nationality": "Húngaro" },
  { "code": "IS", "nationality": "Islandés" },
  { "code": "IN", "nationality": "Indio" },
  { "code": "ID", "nationality": "Indonesio" },
  { "code": "IR", "nationality": "Iraní" },
  { "code": "IQ", "nationality": "Iraquí" },
  { "code": "IE", "nationality": "Irlandés" },
  { "code": "IL", "nationality": "Israelí" },
  { "code": "IT", "nationality": "Italiano" },
  { "code": "JM", "nationality": "Jamaicano" },
  { "code": "JP", "nationality": "Japonés" },
  { "code": "JO", "nationality": "Jordano" },
  { "code": "KZ", "nationality": "Kazajo" },
  { "code": "KE", "nationality": "Keniata" },
  { "code": "KR", "nationality": "Surcoreano" },
  { "code": "KW", "nationality": "Kuwaití" },
  { "code": "KG", "nationality": "Kirguís" },
  { "code": "LA", "nationality": "Laosiano" },
  { "code": "LV", "nationality": "Letón" },
  { "code": "LB", "nationality": "Libanés" },
  { "code": "LS", "nationality": "Lesotense" },
  { "code": "LR", "nationality": "Liberiano" },
  { "code": "LY", "nationality": "Libio" },
  { "code": "LT", "nationality": "Lituano" },
  { "code": "LU", "nationality": "Luxemburgués" },
  { "code": "MG", "nationality": "Malgache" },
  { "code": "MW", "nationality": "Malauí" },
  { "code": "MY", "nationality": "Malasio" },
  { "code": "MV", "nationality": "Maldivo" },
  { "code": "ML", "nationality": "Maliense" },
  { "code": "MT", "nationality": "Maltés" },
  { "code": "MR", "nationality": "Mauritano" },
  { "code": "MU", "nationality": "Mauriciano" },
  { "code": "MX", "nationality": "Mexicano" },
  { "code": "MD", "nationality": "Moldavo" },
  { "code": "MC", "nationality": "Monegasco" },
  { "code": "MN", "nationality": "Mongol" },
  { "code": "MA", "nationality": "Marroquí" },
  { "code": "MZ", "nationality": "Mozambiqueño" },
  { "code": "MM", "nationality": "Birmano" },
  { "code": "NA", "nationality": "Namibio" },
  { "code": "NP", "nationality": "Nepalí" },
  { "code": "NL", "nationality": "Neerlandés" },
  { "code": "NZ", "nationality": "Neozelandés" },
  { "code": "NI", "nationality": "Nicaragüense" },
  { "code": "NE", "nationality": "Nigerino" },
  { "code": "NG", "nationality": "Nigeriano" },
  { "code": "NO", "nationality": "Noruego" },
  { "code": "OM", "nationality": "Omaní" },
  { "code": "PK", "nationality": "Pakistaní" },
  { "code": "PA", "nationality": "Panameño" },
  { "code": "PG", "nationality": "Papú" },
  { "code": "PY", "nationality": "Paraguayo" },
  { "code": "PE", "nationality": "Peruano" },
  { "code": "PH", "nationality": "Filipino" },
  { "code": "PL", "nationality": "Polaco" },
  { "code": "PT", "nationality": "Portugués" },
  { "code": "QA", "nationality": "Catarí" },
  { "code": "RO", "nationality": "Rumano" },
  { "code": "RU", "nationality": "Ruso" },
  { "code": "RW", "nationality": "Ruandés" },
  { "code": "SA", "nationality": "Saudí" },
  { "code": "SN", "nationality": "Senegalés" },
  { "code": "RS", "nationality": "Serbio" },
  { "code": "SG", "nationality": "Singapurense" },
  { "code": "SK", "nationality": "Eslovaco" },
  { "code": "SI", "nationality": "Esloveno" },
  { "code": "SO", "nationality": "Somalí" },
  { "code": "ZA", "nationality": "Sudafricano" },
  { "code": "ES", "nationality": "Español" },
  { "code": "LK", "nationality": "Ceilanés" },
  { "code": "SD", "nationality": "Sudanés" },
  { "code": "SE", "nationality": "Sueco" },
  { "code": "CH", "nationality": "Suizo" },
  { "code": "SY", "nationality": "Sirio" },
  { "code": "TW", "nationality": "Taiwanés" },
  { "code": "TJ", "nationality": "Tayiko" },
  { "code": "TZ", "nationality": "Tanzano" },
  { "code": "TH", "nationality": "Tailandés" },
  { "code": "TG", "nationality": "Togolés" },
  { "code": "TT", "nationality": "Trinitense o Tobagense" },
  { "code": "TN", "nationality": "Tunecino" },
  { "code": "TR", "nationality": "Turco" },
  { "code": "TM", "nationality": "Turcomano" },
  { "code": "UG", "nationality": "Ugandés" },
  { "code": "UA", "nationality": "Ucraniano" },
  { "code": "AE", "nationality": "Emiratí" },
  { "code": "GB", "nationality": "Británico" },
  { "code": "US", "nationality": "Americano" },
  { "code": "UY", "nationality": "Uruguayo" },
  { "code": "UZ", "nationality": "Uzbeko" },
  { "code": "VE", "nationality": "Venezolano" },
  { "code": "VN", "nationality": "Vietnamita" },
  { "code": "YE", "nationality": "Yemení" },
  { "code": "ZM", "nationality": "Zambiano" },
  { "code": "ZW", "nationality": "Zimbabuense" }
]

